import { render, staticRenderFns } from "./share-trip.vue?vue&type=template&id=78d31590&"
import script from "./share-trip.vue?vue&type=script&lang=js&"
export * from "./share-trip.vue?vue&type=script&lang=js&"
import style0 from "./share-trip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports